export const ActiveCell = (props: any) => {
    const inactive = props.dataItem?.inactiveDate;
    return <td>
        {inactive ? "Inactive" : "Active"}
    </td>
}
export const FacilityNameCell = (props: any) => {
    const facilityName = props.dataItem.lab?.facilityName;
    return <td>
        {facilityName ? facilityName : 'Lab Not Found'}
    </td>
}
export const PipetCell = (props: any) => {
    const pipetName = props.dataItem.pipet?.serialNumber;
    return <td>
        {pipetName ? pipetName : 'Pipet Not Found'}
    </td>
}

export const OperatorNameCell = (props: any) => {
    const operatorName = props.dataItem.operator?.operatorName;
    return <td>
        {operatorName ? operatorName : 'Operator Not Found'}
    </td>
}

